import { alpha } from '@mui/material/styles';

export const WORKSPACE_TOP_BAR_MIN_HEIGHT = 54;

export const WORKSPACE_CONTENT_MAX_WIDTH = {
  xs: '100%',
  lg: '95%',
};

export const getWorkspaceTokens = (theme) => {
  const workspace = theme.workspace || {};
  const surface = workspace.surface || theme.background?.backgroundColor || theme.palette.background.default;
  const rail = workspace.rail || theme.background?.footer || theme.palette.background.paper;
  const toolbar = workspace.toolbar || theme.background?.footer || theme.palette.background.paper;
  const header = workspace.header || theme.table?.header || theme.palette.background.paper;
  const muted = workspace.muted || theme.tableHeader?.highlight || theme.palette.action.hover;
  const selected = workspace.selected || (
    theme.palette.mode === 'light'
      ? alpha(theme.palette.primary.main, 0.13)
      : alpha(theme.palette.primary.main, 0.2)
  );
  const hover = workspace.hover || (
    theme.palette.mode === 'light'
      ? alpha(theme.palette.primary.main, 0.08)
      : alpha(theme.palette.primary.main, 0.18)
  );

  return {
    surface,
    rail,
    toolbar,
    header,
    muted,
    selected,
    hover,
    radius: workspace.radius || 6,
    controlHeight: workspace.controlHeight || 30,
    outerInset: workspace.outerInset || {
      compact: { xs: 1, sm: 1.5, md: 2 },
      comfortable: { xs: 1, sm: 1.5, md: 2 },
    },
    gutter: workspace.gutter || {
      compact: { xs: 1, sm: 1.5, md: 2 },
      comfortable: { xs: 1, sm: 1.5, md: 2 },
    },
    gap: workspace.gap || {
      compact: { xs: 0.75, md: 1 },
      comfortable: { xs: 1, md: 1.5 },
    },
    contentMaxWidth: workspace.contentMaxWidth || WORKSPACE_CONTENT_MAX_WIDTH,
    objectMaxWidth: workspace.objectMaxWidth || {
      chart: { xs: '100%', md: 'min(100%, 1300px)' },
      table: { xs: '100%', md: 'min(100%, 1180px)' },
      full: '100%',
    },
    objectMinHeight: workspace.objectMinHeight || {
      chart: { xs: 300, sm: 320, md: 340 },
      table: { xs: 260, sm: 280, md: 280 },
    },
  };
};
